import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  AppBar,
  CircularProgress,
  Grid,
  IconButton,
  Toolbar,
} from '@material-ui/core';
import { useParams } from 'react-router-dom';
import Answers from '@root/db/entity/Answers';
import { ReactComponent as LogoWhite } from '../../../styles/logos/LogoWhite.svg';
import { TitleContainer } from './styles';
import LeftCard from './LeftCard';
import RightCard from './RightCard';

interface IParamTypes {
  id: string;
}

const ResultBreakdownCard = () => {
  const { id } = useParams<IParamTypes>();

  const [resultData, setResultData] = useState<Answers | null>(null);
  const [allAnswerData, setAllAnswerData] = useState<Answers[] | null>(null);
  const [requestHasFailed, setRequestHasFailed] = useState<boolean>(false);

  useEffect(() => {
    const getResultData = async () => {
      const response = await fetch(`/api/answers/${id}`);

      if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        setRequestHasFailed(true);
        console.error(message);
      } else {
        const data: Answers = JSON.parse(await response.text());
        setResultData(data);
      }
    };
    const getStatsData = async () => {
      const response = await fetch(`/api/stats`);

      if (!response.ok) {
        const message = `An error has occured: ${response.status}`;
        setRequestHasFailed(true);
        console.error(message);
      } else {
        const data: Answers[] = JSON.parse(await response.text());
        setAllAnswerData(data);
      }
    };

    getResultData();
    getStatsData();
  }, [id]);

  if (requestHasFailed) {
    return <p>Unable to find results. This might be due to an invalid URL.</p>;
  }

  if (!resultData) {
    return (
      <ProgressContainer>
        <CircularProgress size="100px" />
      </ProgressContainer>
    );
  }

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignContent="center"
          >
            <HeaderTypography>Dare your distributors</HeaderTypography>
            <IconButton
              href="https://www.business-sweden.com/"
              edge="end"
              aria-haspopup="true"
            >
              <LogoWhite width="50" height="50" />
            </IconButton>
          </Grid>
        </Toolbar>
      </AppBar>
      <SubheaderContainer>
        <TitleContainer>Your overall result</TitleContainer>
        <UserInfoContainer>
          {resultData?.user.email || 'loading'}
        </UserInfoContainer>
      </SubheaderContainer>
      <ResultCardContainer>
        {allAnswerData && (
          <LeftCard allAnswerData={allAnswerData} resultData={resultData} />
        )}
        {allAnswerData && (
          <RightCard allAnswerData={allAnswerData} resultData={resultData} />
        )}
      </ResultCardContainer>
    </>
  );
};

const ResultCardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;

const SubheaderContainer = styled.div`
  display: 'flex';
  flex-direction: 'column';
  margin: 20px;
`;

const UserInfoContainer = styled.div`
  width: 166px;
  height: 32px;
  left: 26px;
  top: 123px;

  white-space: nowrap;
  font-family: EB Garamond;
  font-style: italic;
  font-weight: normal;
  font-size: 20px;
  line-height: 32px;

  letter-spacing: 0.15px;

  color: #000000;
`;

const HeaderTypography = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 56px;
  letter-spacing: 0px;
  text-align: left;
  text-transform: uppercase;
  display: flex;
  align-items: center;
`;

const ProgressContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default ResultBreakdownCard;
